import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { MultiSelect } from 'primeng/multiselect';
import { SelectModel } from '../../../../core/models/select.model';
import { SelectMultipleValueInterface, SelectMultipleInterface } from '../../../../core/interfaces/select-multiple.interface';
import { PaisRiesgoService } from 'src/app/core/providers/services/pais-riesgo/pais-riesgo.service';
import { take, tap } from 'rxjs/operators';
import { Numbers } from 'src/app/utils/constants';
import { RiskCountryRes } from 'src/app/core/interfaces/risk-country-res.interface';

@Component({
  selector: 'app-select-multiple',
  templateUrl: './select-multiple.component.html',
  styleUrls: ['./select-multiple.component.scss']
})
export class SelectMultipleComponent implements OnInit, OnChanges {

  @Input() FORM_DATA: FormGroup;
  /**
   * @description Es la configuracion del formulario
   */
  @Input() DATA_CONFIG: SelectModel;
  @Input() LIMIT_SELECTION: number = null;
  @Input() DATA_CHANGE: any;
  @Input() DISABLED: any;
  @Input() COUNTRY_RISK_CHANGE: any;
  @Input() SHOW_CLEAN_BTN: any = false;
  @ViewChild('multiSelectId', { static: false }) multiSelectId: MultiSelect;

  multipleOpts: SelectMultipleInterface[];

  selections: SelectMultipleValueInterface[] = [];

  multiSelShow = false;

  fieldName: any;
  fieldErrors: any;
  fieldHasErrorB = false;
  fieldTouch = false;
  fieldRequired = false;
  isDisabled = false;
  fieldCountryRiskError = false;
  fieldCountryRiskAlert = false;
  /**
   * @description constructor
   * @params countryRisk
   */
  constructor(
    private countryRisk: PaisRiesgoService
  ) {
    this.countryRisk = countryRisk;
  }
/**
 * @description metodo inicio
 */
  ngOnInit(): void {
    this.multipleOpts = this.DATA_CONFIG.options.multiple;
    const TIMER: any = setTimeout(() => {
      // Esperamos un momento para que se carguen los datos del multiselect del ViewChil
      if (this.multiSelectId) {
        // Sobreescribimos la funcion que despacha eventos de click para evitar
        // que el panel de seleccion multiple se abra al hacer click
        this.multiSelectId.onMouseclick = (() => null);

        this.fieldName = this.DATA_CONFIG.linkFormPath;
        this.fieldRequired = false;
        this.getError(this.fieldName);
        clearTimeout(TIMER);
      }
    }, Numbers.number20);

    this.selections = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
  }
/**
 * @description metodo cambio
 * @params changes
 */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.DISABLED && changes.DISABLED.currentValue) {
      this.isDisabled = changes.DISABLED.currentValue;
      if (this.isDisabled) {
        this.LIMIT_SELECTION = 1;
      } else {
        this.LIMIT_SELECTION = null;
      }
    }
    if (changes.DATA_CHANGE && changes.DATA_CHANGE.currentValue) {
      const AUX_CHANGE: any = changes.DATA_CHANGE.currentValue;
      if (AUX_CHANGE.name && AUX_CHANGE.name === 'destiny') {
        const canBeInsured: { id: any; name: any; code: any; } = {
          id: AUX_CHANGE.value[0].id,
          name: AUX_CHANGE.value[0].name,
          code: AUX_CHANGE.value[0].code
        };
        this.selections = [];
        this.selections.push(canBeInsured);
        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(this.selections);
      }
    }
  }
  /**
   * @description abre o cierra el multiselect
   */
  toggleMultiSel(): void {

    // this.multiSelShow Nos dice si esta abierto o cerrado el multiselect
    if (!this.isDisabled && this.multiSelShow === true) {
      // Si esta abierto lo cerramos
      this.multiSelectId.hide();
    } else {
      if (!this.isDisabled) {
        const TIMER: any = setTimeout(() => {
          // Si esta cerrado lo abrimos un tiempo despues para evitar
          //  que se solapen eventos de cierre / apertura
          this.multiSelectId.show();
          clearTimeout(TIMER);
        }, Numbers.number20);
      }
    }

  }
  /**
   * @description Nos dice si esta abierto o cerrado el multiselect
   * @params ev
   */
  setMultiSelShow(ev: boolean): void {
    this.multiSelShow = ev;
  }
  /**
   * @description actualiza los datos
   */
  updateData(): void {
    if (!this.selections) { return; }
    const LIST_NAMES: SelectMultipleValueInterface[] = this.selections.map(e => e);
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(LIST_NAMES);
    if (!this.SHOW_CLEAN_BTN) {
      this.validateCountryRisk(LIST_NAMES);
    }
    if (LIST_NAMES.length > 0 && this.fieldRequired) {
      this.fieldHasErrorB = false;
    }
    if (LIST_NAMES.length <= 0 && this.fieldRequired) {
      this.fieldHasErrorB = true;
    }
    if (this.fieldRequired && (LIST_NAMES.length > 0)) {
      this.FORM_DATA.get(this.fieldName).setErrors(null);
    } else {
      this.FORM_DATA.get(this.fieldName).setErrors({ required: true });
    }
  }
  /**
   * @description valida pais
   * @params val
   */
  validateCountryRisk(val: SelectMultipleValueInterface[]): void {
    if (val.length > 0) {
      const sentCountries: string[] = [];
      for (const element of val) {
        sentCountries.push(element.name);
      }
      this.countryRisk.getCountryRisk(sentCountries)
        .pipe(take(1))
        .subscribe((res: RiskCountryRes[]) => {
          this.checkCountryRisk(res);
        });
    } else {
      this.fieldCountryRiskError = false;
      this.fieldHasErrorB = true;
      const LINK_FIELD: string[] = this.DATA_CONFIG.linkFormPath;
      this.FORM_DATA.get(LINK_FIELD).setErrors({ required: true });
    }
  }

  /**
   * chequea
   * @param paises paises list
   */
  checkCountryRisk(paises: RiskCountryRes[]): void {
    this.fieldCountryRiskError = false;
    this.fieldCountryRiskAlert = false;
    const paisesRiesgo = paises.filter((pais: RiskCountryRes) => pais.riesgo === 1);
    if (paisesRiesgo.length > 0) {
      this.fieldCountryRiskError = true;
      const paisesRiesgoAlerta = paisesRiesgo.filter((pais: RiskCountryRes) => pais.indAlertaRiesgo === 1);

      if (paisesRiesgoAlerta.length > 0) {
        this.fieldCountryRiskAlert = true;
      } else {
        this.fieldCountryRiskAlert = false;
      }
    }

    const LINK_FIELD: string[] = this.DATA_CONFIG.linkFormPath;
    let errorsA: ValidationErrors = null;
    let errorE = false;
    if (this.fieldCountryRiskError) {
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(LINK_FIELD).setErrors({ required: true });
    } else {
      this.fieldHasErrorB = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(LINK_FIELD).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) { errorsA = null;
      } else { errorsA = ERRORS; }
      this.FORM_DATA.get(LINK_FIELD).setErrors(errorsA);
      // this.FORM_DATA.get( LINK_FIELD ).updateValueAndValidity();
    }
  }

  // Funcion ya no usada. Quitar
  /**
   * @description chequea
   * @params codeStatus
   */
  checkFieldCountryRiskError(codeStatus: number): void {
    this.fieldCountryRiskError = false;
    if (codeStatus === 1) { this.fieldCountryRiskError = true; }
    const LINK_FIELD: string[] = this.DATA_CONFIG.linkFormPath;
    let errorsA: ValidationErrors = null;
    let errorE = false;
    if (this.fieldCountryRiskError) {
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(LINK_FIELD).setErrors({ required: true });
    } else {
      this.fieldHasErrorB = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(LINK_FIELD).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) { errorsA = null;
      } else { errorsA = ERRORS; }
      this.FORM_DATA.get(LINK_FIELD).setErrors(errorsA);
      // this.FORM_DATA.get( linkfield ).updateValueAndValidity();
    }
  }
  /**
   * @description borrar chip
   * @params chip
   */
  deleteChip(chip: SelectMultipleValueInterface): void {
    if (!this.isDisabled) {
      // Conseguimos el array de nombres del formulario
      const VALUE_FORM: SelectMultipleValueInterface[] = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
      // Buscamos el nombre de la chip a eliminar en el array de nombres del formulario
      const idxToDelete: number = VALUE_FORM.findIndex(el => el.id === chip.id);
      // Eliminamos el la chip en el nuevo valor del formulario
      VALUE_FORM.splice(idxToDelete, 1);
      // Eliminamos el la chip en el array de nombres seleccionados en la caja de chips
      this.selections.splice(idxToDelete, 1);
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(VALUE_FORM);
      if (!this.SHOW_CLEAN_BTN) {
        this.validateCountryRisk(VALUE_FORM);
      }
    }
  }
  /**
   * @description foco del input
   * @param field field to mark focus
   */
  onFocusInput(controlName: any): void {
    this.FORM_DATA.get(controlName).markAsUntouched();
    this.fieldTouch = true;
    const LIST_NAMES: string[] = this.selections.map(e => e.name);
    if (LIST_NAMES.length > 0 && this.fieldRequired) {
      this.fieldHasErrorB = false;
    }
    if (LIST_NAMES.length <= 0 && this.fieldRequired) {
      this.fieldHasErrorB = true;
    }
  }
  /**
   *
   * @param field field to check erros
   */
  getError(controlName: string): string {
    let errorMsg = '';
    this.fieldErrors = '';
    const CONTROL: AbstractControl = this.FORM_DATA.get(controlName);
    this.fieldRequired = false;
    if (this.DATA_CONFIG.select.error !== '') { this.fieldRequired = true; }
    if (CONTROL.invalid && CONTROL.errors !== null) {
      errorMsg = JSON.stringify(CONTROL.errors);
      this.fieldErrors = CONTROL.errors;
    }
    return errorMsg;
  }
  /**
   * @description limpiar seleccion
   */
  cleanSelections(): void {
    const LIST_ITEMS: AbstractControl = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath);
    if (LIST_ITEMS) {
      LIST_ITEMS.setValue([]);
      this.selections = LIST_ITEMS.value;
    } else {
      console.error('No hay path');
    }
  }
}
